import React from 'react';
import {getComponentConfig} from '../../utils/components';
import ContentLoader from "../layout/ContentLoader";
import PropTypes from "prop-types";
import {store} from "../../store";
import {showModal} from "../../actions";
import {trace} from "../../utils/request";
import Icon from "./Icon";
import {set} from "../../utils/dotutils";

export class ComponentConfig extends React.Component {

    static propTypes = {
        componentName: PropTypes.string,
        componentConfigAs: PropTypes.string,
        loader: PropTypes.any
    }

    state = {
        isLoading: true,
        failed: false
    }

    constructor(props) {
        super(props);
        this.loadConfig();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if(prevProps.componentName !== this.props.componentName) {
            this.loadConfig();
        }
    }

    loadConfig = async () => {
        this.abort && this.abort();
        let aborter = false;
        const abort = () => {
            aborter = true;
        }
        const load = async () => {
            if (!this.props.componentName) {
                return;
            }
            try {
                const componentConfig = await getComponentConfig(this.props.componentName);
                if (aborter) return;
                if (!componentConfig) {
                    throw {message: "Empty config!"};
                }
                this.setState({isLoading: false, config: componentConfig});
            } catch (e) {
                if (aborter) return;
                console.error(e);
                this.setState({failed: e, isLoading: false});
                !this.props.onFailure && store.dispatch(showModal({
                    size: "large",
                    theme: "danger",
                    header: "Szerveroldali hiba",
                    body: trace(e.response.data)
                }));
            }
        };
        this.abort = abort;
        if (!this.state.isLoading) {
            this.setState({isLoading: true, failed: false}, load);
        } else {
            load();
        }
    }

    render () {
        const thisProps = {...this.props};
        delete thisProps.children;
        let component = null;
        if (!this.state.isLoading && !this.state.failed) {
            if (this.props.children instanceof Function) {
                const props = {
                    ...thisProps
                };
                set(props, this.props.componentConfigAs || "componentConfig", this.state.config);
                component = this.props.children(props);
            } else {
                component = React.Children.map(this.props.children, (child) => {
                    if (child) {
                        const props = {
                            ...thisProps, ...child.props,
                        };
                        set(props, this.props.componentConfigAs || "componentConfig", this.state.config);
                        return <child.type {...props}/>;
                    }
                    return child;
                });
            }
        } else if(this.state.failed) {
            if (this.props.onFailure) {
                component = this.props.onFailure && this.props.onFailure(this.state.failed);
            }
        }
        let LoaderStyle = ContentLoader;
        if (this.props.loader !== undefined) {
            LoaderStyle = this.props.loader;
        }
        if (this.state.isLoading) {
            if (LoaderStyle) {
                return <LoaderStyle>
                    {component}
                </LoaderStyle>;
            } else {
                return null;
            }
        } else {
            return component || <span onClick={(e) => {
                e && e.preventDefault();
                console.error(this.state.failed);
                store.dispatch(showModal({
                    size: "large",
                    theme: "danger",
                    header: "Szerveroldali hiba",
                    body: trace(this.state.failed.response.data)
                }))
            }}>
                <Icon lib="fa" name="exclamation-triangle" />
            </span>;
        }
    }
}

export default ComponentConfig;